import Authenticated from "./Authenticated";
import PartialAuth from "./PartialAuth";
import SubscriptionProtected from "./SubscriptionProtected";

const ProtectedRoutes = {
  Authenticated,
  PartialAuth,
  SubscriptionProtected,
};

export default ProtectedRoutes;